import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "selected", "onSelected", "full", "clampText", "isDark", "dark", "isTransparency", "transparencyMode", "className", "datatestid", "data-testid", "htmlProps"];
import cn from 'classnames';
import { BACKGROUND_COLOR_CLASSNAMES, OPTION_WRAPPER } from "./classnames";
import MenuItem from "./MenuItem";
import { jsx as _jsx } from "react/jsx-runtime";
function Menu(_ref) {
  var options = _ref.options,
    selected = _ref.selected,
    onSelected = _ref.onSelected,
    full = _ref.full,
    clampText = _ref.clampText,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isTransparency = _ref.isTransparency,
    transparencyMode = _ref.transparencyMode,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    datatestid = _ref.datatestid,
    dataTestId = _ref['data-testid'],
    htmlProps = _ref.htmlProps,
    menuProps = _objectWithoutProperties(_ref, _excluded);
  var backgroundState = isDark || dark ? 'dark' : 'light';
  if (isTransparency || transparencyMode) {
    backgroundState = 'transparency';
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
    className: cn(OPTION_WRAPPER, isDark || dark ? 'crehui-scrollable-dark ' : 'crehui-scrollable', full ? 'w-full' : 'sm:min-w-280', BACKGROUND_COLOR_CLASSNAMES[backgroundState], className),
    "data-testid": dataTestId || datatestid
  }, menuProps), htmlProps), {}, {
    children: options.map(function (opt) {
      var onSelect = function onSelect() {
        if (onSelected) {
          onSelected(opt);
        }
      };
      return /*#__PURE__*/_jsx(MenuItem, {
        onClick: onSelect,
        selected: selected && selected.value === opt.value,
        jsxLabel: opt.jsxLabel,
        label: opt.label,
        clampText: clampText,
        isDark: isDark || dark,
        isTransparency: isTransparency || transparencyMode,
        "data-testid":
        // @ts-ignore
        opt['data-testid'] || "".concat(dataTestId || datatestid, "-").concat(opt.label)
      }, "option-menu-".concat(opt.label, "-").concat(opt.value));
    })
  }));
}
export default Menu;